<template>
    <div v-if="id">
        <div
            :id="id" class="lottie"
            :style="{width: width + 'px', height: height + 'px'}"
        ></div>
    </div>
</template>

<script>
import lottie from 'lottie-web';
export default {
    name: '',
    components: {},
    props: {
        // 必传，canvas id，不要重复
        id: {
            type: String,
            default: ''
        },
        height: {
            type: Number,
            default: 300
        },
        width: {
            type: Number,
            default: 300
        },
        path: {
            type: String,
            default: ''
        }
    },
    mounted() {
        lottie.loadAnimation({
            container: document.getElementById(this.id),
            renderer: 'svg', // 或 'canvas'
            loop: true,
            autoplay: true,
            path: this.path // 动画JSON文件路径
        });
    }
};
</script>